import * as CONSTANTS from '../constants/actions/parts';

/**
 * @name applyHash
 * @function 
 * @description Applies hash values to parts
 * @param {boolean} [compare=false]
 */
export const applyHash = ( compare=false, sorted, filters, selected, ignoredBlanks, andToggle, s3Type ) => {
    return dispatch => dispatch({ type: CONSTANTS.APPLY_HASH_CHANGE, payload: { compare, filters, sorted, selected, ignoredBlanks, andToggle, s3Type } });
}

/**
* @name resetParts
* @function 
* @description Reset parts value
*/
export const resetParts = () => {
    return dispatch => dispatch({ type: CONSTANTS.RESET_PARTS });
}

/**
 * @name select
 * @function 
 * @description Selects a part
 * @param {string} id id of the row to select
 */
export const select = (id, parts) => {
    return dispatch => dispatch({ type: CONSTANTS.SELECT_PART, payload: { id, parts } });
}

/**
 * @name setPageSize
 * @function 
 * @description Sets the current page
 * @param {string} pageSize pageSize number to display
 */
export const setPageSize = pageSize => {
    return dispatch => dispatch({ type: CONSTANTS.SET_PAGE_SIZE, payload: { pageSize } });
}

/**
 * @name setPage
 * @function 
 * @description Sets the current page
 * @param {string} page page number to display
 */
 export const setPage = page => {
    return dispatch => dispatch({ type: CONSTANTS.SET_PAGE, payload: { page } });
}

/**
 * @name setPopup
 * @function 
 * @description Selects a part to display inside the popup
 * @param {Object} [coords={}] BoundingClientRect object for the controller being referenced
 * @param {Object} [id=null] row ID of the part being hovered
 */
export const setPopup = ( coords={}, id=null ) => {
    return dispatch => dispatch({ type: CONSTANTS.SET_POPUP, payload: { coords, id } });
}